import { CREATE_TASKS_TITLE_LENGTH } from './types';

export function getTasksTitle(task: string): string {
  return task.length > CREATE_TASKS_TITLE_LENGTH ? `${task.slice(0, CREATE_TASKS_TITLE_LENGTH)}...` : task;
}
